// extracted by mini-css-extract-plugin
export default {"buttonDownload":"zip-button-file_buttonDownload__PUFt+","downloadArrow":"zip-button-file_downloadArrow__xmH-Z"};